// Replaces a re-export of pino's own Logger, so consumers that already import this type get their
// log payloads checked against the reserved field names with no change on their side.
export type { Logger, SafeBindings } from "./reservedLogFields";
export * from "./logger";
export { stringifyLogValue } from "./utils/jsonReplacer";
export { enableWorkerLogging, initLoggingTransmission } from "./utils/sendToBackend";
